export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["кеше"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])}
}